var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClearbitIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "color-c",
    x1: 54,
    x2: 72,
    y1: 36,
    y2: 72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEF2FE",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBF1FE",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "color-b",
    x1: 36,
    x2: 54,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57BCFD",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51B5FD",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "color-a",
    x1: 19.092,
    x2: 31.82,
    y2: 50.912,
    gradientTransform: "scale(.70711 1.4142)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1CA7FD",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#148CFC",
    offset: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(.88889)",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m72 36v16.771l-0.0041 0.86664c-0.05897 6.0353-0.75018 8.353-1.9994 10.689-1.3073 2.4444-3.2257 4.3629-5.6702 5.6702l-0.32618 0.17068c-2.3422 1.1971-4.8401 1.8328-11.229 1.8328h-16.771v-36z",
    fill: "url(#color-c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.326 2.0035c2.4444 1.3073 4.3629 3.2257 5.6702 5.6702l0.17068 0.32618c1.1971 2.3422 1.8328 4.8401 1.8328 11.229v16.771h-36v-36h16.771c6.6864 0 9.111 0.69619 11.555 2.0035z",
    fill: "url(#color-b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36 0v72h-16.771l-0.86664-0.0041c-6.0353-0.058991-8.353-0.75019-10.689-1.9994-2.4444-1.3073-4.3629-3.2257-5.6702-5.6702l-0.17068-0.32618c-1.1971-2.3422-1.8328-4.8401-1.8328-11.229v-33.542c0-6.6864 0.69619-9.111 2.0035-11.555 1.3073-2.4444 3.2257-4.3629 5.6702-5.6702l0.32618-0.17068c2.3422-1.1971 4.8401-1.8328 11.229-1.8328z",
    fill: "url(#color-a)"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearbitIcon);
export default __webpack_public_path__ + "assets/media/clearbitIcon.ff37a37d.svg";
export { ForwardRef as ReactComponent };